import { EnvelopeIcon } from "@sanity/icons"
import { defineField, defineType } from "@sanity-typed/types"
import { SanityValues } from "sanity.config"
import { ctaSchema } from "schemas/objects/cta"
import { background } from "schemas/objects/helpers/background"
import Preview from "schemas/objects/helpers/Preview"

const type = defineType({
  type: "object",
  name: "fullWidthCTA",
  title: "Full Width CTA",
  icon: EnvelopeIcon,

  fieldsets: [...background.fieldsets],

  fields: [
    ...background.fields,
    defineField({
      name: "cta",
      title: "CTA",
      type: ctaSchema.name,
      initialValue: { /*type: "link",*/ hideType: true },
    }),
    defineField({
      name: "body",
      title: "Body",
      type: "string",
    }),
  ],

  components: {
    preview: () => <Preview title={type.title} icon={type.icon} />,
  },
})

export const fullWidthCTAType = type
export type FullWidthCTA = SanityValues["fullWidthCTA"]
export const fullWidthCTASchema = type
